import React from "react";
import { useSelector } from "react-redux";
import { Redirect, Route } from "react-router-dom";

const PrivateRoute = ({ component: Component, ...rest }) => {
  // Add your own authentication on the below line.
  const { user_details } = useSelector((state) => state.authReducer);
  return (
    <Route
      {...rest}
      render={(props) => {
        if (
          user_details &&
          user_details !== null &&
          user_details?.user?.merchant
        ) {
          // return <Component {...props} />;
          const merchant = user_details?.user?.merchant;
          const setupPaths = [
            "/gm-welcome",
            "/welcome",
            "/setup-wizard",
            "/setup-wizard-two",
            "/setup-wizard-three",
            "/setup-wizard-four",
            "/setup-wizard-five",
            "/setup-wizard-six",
            "/setup-wizard-seven",
            "/setup-wizard-eight",
            "/setup-wizard-nine",
            "/setup-wizard-ten",
          ];
          if (
            merchant?.wizard_last_step == "gm_welcome" &&
            rest.path !== "/gm-welcome"
          ) {
            return <Redirect to={{ pathname: "/gm-welcome" }} />;
          } else if (
            merchant?.wizard_last_step == "welcome" &&
            rest.path !== "/welcome"
          ) {
            return <Redirect to={{ pathname: "/welcome" }} />;
          } else if (
            merchant?.wizard_last_step == "tab0" &&
            rest.path !== "/setup-wizard"
          ) {
            return <Redirect to={{ pathname: "/setup-wizard" }} />;
          } else if (
            merchant?.wizard_last_step == "tab1" &&
            rest.path !== "/setup-wizard-two"
          ) {
            return <Redirect to={{ pathname: "/setup-wizard-two" }} />;
          } else if (
            merchant?.wizard_last_step == "tab2" &&
            rest.path !== "/setup-wizard-three"
          ) {
            return <Redirect to={{ pathname: "/setup-wizard-three" }} />;
          } else if (
            merchant?.wizard_last_step == "tab3" &&
            rest.path !== "/setup-wizard-four"
          ) {
            return <Redirect to={{ pathname: "/setup-wizard-four" }} />;
          } else if (
            merchant?.wizard_last_step == "tab4" &&
            rest.path !== "/setup-wizard-five"
          ) {
            return <Redirect to={{ pathname: "/setup-wizard-five" }} />;
          } else if (
            merchant?.wizard_last_step == "tab5" &&
            rest.path !== "/setup-wizard-six"
          ) {
            return <Redirect to={{ pathname: "/setup-wizard-six" }} />;
          } else if (
            merchant?.wizard_last_step == "tab6" &&
            rest.path !== "/setup-wizard-seven"
          ) {
            return <Redirect to={{ pathname: "/setup-wizard-seven" }} />;
          } else if (
            merchant?.wizard_last_step == "tab7" &&
            rest.path !== "/setup-wizard-eight"
          ) {
            return <Redirect to={{ pathname: "/setup-wizard-eight" }} />;
          } else if (
            merchant?.wizard_last_step == "tab8" &&
            rest.path !== "/setup-wizard-nine"
          ) {
            return <Redirect to={{ pathname: "/setup-wizard-nine" }} />;
          } else if (
            merchant?.wizard_last_step == "tab9" &&
            rest.path !== "/setup-wizard-ten"
          ) {
            return <Redirect to={{ pathname: "/setup-wizard-ten" }} />;
          } else if (
            merchant?.wizard_last_step == "" &&
            setupPaths.includes(rest.path)
          ) {
            return <Redirect to={{ pathname: "/dashboard" }} />;
          }
          return <Component {...props} />;
        } else {
          return <Redirect to={{ pathname: "/" }} />;
        }
      }}
    />
  );
};

export default PrivateRoute;
